export default {
    templateCenter: {
        searchTemplate: 'Search Template',
        allTemplate: 'All',
        workflow: 'Workflow',
        embedding: 'Embedding',
        lightApp: 'LightApp',
        Agent: 'Agent',
        recentUpdate: 'Update ',
        resourceRequiredTip: 'Resource ',
        templateContains: 'Template Contains',
        templateContainsTip: ' function, need to upgrade after copying',
        seeTemplateDescription: 'See Template Description',
        copy: 'Copy',
        duplicate: 'Clone',
        templateCopy: 'Template Clone',
        templateCopyTip: 'The clone will create the same agent or workflow directly for you. The resources contained in the template will take up the capacity of the agent, workflow, plugins, knowledge base, database (if any).',
        templateCopyTip2: 'The Settings and data in the template are only used as examples, and can be adjusted or deleted according to actual needs after duplicating.',
        resourceRequired: 'Resource',
        appTip: 'Agent:',
        databaseTip: 'Database:',
        rowCount: 'Row:',
        resourceNotEnough: 'Resource Not Enough',
        knowledgeBaseTip: 'Knowledge Base ',
        customPluginTip: 'Plugin ',
        workflowTip: 'Workflow ',
        goUpgrade: 'Go Upgrade',
        app: 'Agent',
        database: 'Database',
        customPlugin: 'Plugin',
        knowledgeBase: 'Knowledge Base',
        copySuccess: 'Copy Success',
        resourceContains: 'Resource  ',
        experienceNow: 'Chat',
    }
}